/**
 * @generated SignedSource<<429a50ad6547b752c57ef12aeefc6677>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FieldDetailsFragment$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"FieldDetailsAttributesFragment" | "FieldDetailsLabelsFragment" | "FieldDetailsReportsFragment" | "FieldMap">;
  readonly " $fragmentType": "FieldDetailsFragment";
};
export type FieldDetailsFragment$key = {
  readonly " $data"?: FieldDetailsFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"FieldDetailsFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FieldDetailsFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FieldDetailsAttributesFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FieldDetailsReportsFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FieldDetailsLabelsFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FieldMap"
    }
  ],
  "type": "FieldNode",
  "abstractKey": null
};

(node as any).hash = "9e10df351188c0a9158207cca666f9a9";

export default node;
